module.exports = __webpack_public_path__ + "assets/assignment-inactive.b6e67fda.svg";